<template src="./SharedMessageBase.html"></template>
<script>
import {
  ToUsersMixin,
  CommonMixin
} from "@/components/send-message/SharedMessageBase";
export default {
  name: "SendMessageView",
  mixins: [ToUsersMixin, CommonMixin],
  methods: {}
};
</script>

<style src="../lib/multiselect-compat.css"></style>
<style src="./SharedMessageBase.css"></style>
